import React from 'react';

export default function InputPane({
  label,
  value,
  onChange,
  placeholder,
  error
}) {
  return (
    <div className="input-pane">
      <div className="input-header">
        <label className="input-label">{label}</label>
        {error && (
          <span className="input-error" title={error}>
            ⚠ Error
          </span>
        )}
      </div>
      <textarea
        className={`input-textarea ${error ? 'has-error' : ''}`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        spellCheck={false}
      />
    </div>
  );
}
